import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: true,
  name: 'tiMomentDate',
})
export class MomentDatePipe implements PipeTransform {
  transform(value: Date, format = ''): string {
    return value ? moment(value).format(format) : '';
  }
}
